import { Component, Output, EventEmitter, Input } from '@angular/core';
import { BaseComponent } from '@varsity/components';
import {
    LoggingService, TokenService, LocalStorageService,
    NotificationsService, AccountService,
    PlatformService, TicketsService, Ticket
} from "@varsity/services";
import { ViewController, ToastController, NavParams, PopoverController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the ValidateTicketsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'validate-tickets',
    templateUrl: 'validate-tickets.html'
})
export class ValidateTicketsComponent extends BaseComponent {
    @Input() protected validationResult: boolean | null = null;
    @Output() public onValidateClicked: EventEmitter<Ticket[]> = new EventEmitter();
    tickets: Ticket[];
    ticketsWithGateClosed: boolean = false;
    validationToken: string;

    constructor(
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected accountService: AccountService,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected ticketsService: TicketsService,
        protected platformService: PlatformService,
        protected popoverCtrl: PopoverController,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "ValidateTicketsComponent"
        );
    }

    ngOnInit() {
        super.ngOnInit();
        this.tickets = this.navParams.get('tickets');
        // nice example for debounce
        // https://stackoverflow.com/questions/32051273/angular-and-debounce

        if (this.tickets.filter(p => p.GatesClosedFlag).length > 0) {
            this.ticketsWithGateClosed = true;
        }

        if (this.navParams.get('validationToken')) {
            this.validationToken = this.navParams.get('validationToken');
        }
    }

    Cancel() {
        this.viewCtrl.dismiss({
            result: this.validationResult
        });
    }

    ValidateTickets() {
        this.ticketsService.validateTickets(this.tickets, this.validationToken)
            .takeUntil(this.componentDestroyed$)
            .subscribe((result) => {
                if (result.Tickets.filter(p => p.TicketUsed != 1).length > 0 || !result.ResultFlag) {
                    this.validationResult = false;
                    this.showNotification((result.ResultsMessage && result.ResultsMessage.length > 0) ? (result.ResultsMessage, undefined, undefined, "success"): "");
                } else {
                    this.validationResult = true;
                    this.onValidateClicked.emit(result.Tickets);
                }
            }, (error) => {
                this.validationResult = false;
                this.handleError(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/components/validate-tickets/validate-tickets.ts